import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.title', {
          n: _vm.getTotalDevicesNumber
        })) + "\n  ")];
      },
      proxy: true
    }])
  }, [[_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.text', {
    n: _vm.getTotalDevicesNumber
  })))])], _vm.isCalculating ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center p-3"
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "size": 50
    }
  }), _c('p', {
    staticClass: "mt-5"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-info-circle")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.calculatingText')) + "\n          ")], 1)], 1)])], 1)] : _vm.isCalculatingError ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-center align-center p-2"
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-info-circle")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.calculatingErrorText')) + "\n          ")], 1), _c('div', {
    staticClass: "mt-5"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.retryBtn')) + "\n            ")])], 1)])])], 1)] : [_c(VStepper, {
    attrs: {
      "color": _vm.color,
      "non-linear": ""
    },
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c(VStepperHeader, [_c(VStepperStep, {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1",
      "color": _vm.color
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.steps.title1')) + "\n        ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2",
      "color": _vm.color
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.steps.title2')) + "\n        ")]), _c(VDivider), _c(VStepperStep, {
    attrs: {
      "step": "3",
      "color": _vm.color
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.steps.title3')) + "\n        ")])], 1), _c(VStepperItems, [_c(VStepperContent, {
    attrs: {
      "step": "1"
    }
  }, [_c(VSelect, {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.selectMode,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.selectModeLabel'),
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color,
      "outlined": ""
    },
    model: {
      value: _vm.stepForm.selectMode,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "selectMode", $$v);
      },
      expression: "stepForm.selectMode"
    }
  }), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.stepForm.selectMode === null,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n          ")])], 1), _vm.stepForm.selectMode === _vm.modes.CHANGE_META_INFORMATION ? _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatusTitle')))]), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.operationalStatus,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.operationalStatusLabel'),
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color,
      "outlined": ""
    },
    model: {
      value: _vm.stepForm.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "operationalStatus", $$v);
      },
      expression: "stepForm.operationalStatus"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTooltip, {
    attrs: {
      "top": "",
      "disabled": !_vm.hasMultipleTenants
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('core-dtwin-finder', {
          staticClass: "mt-2",
          attrs: {
            "disabled": _vm.hasMultipleTenants,
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.parentLabel'),
            "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
            "objectFilter": _vm.parentSelectorFilter,
            "tenantId": _vm.tenantId,
            "sameTenant": "",
            "hideDetails": ""
          },
          model: {
            value: _vm.stepForm.parentId,
            callback: function ($$v) {
              _vm.$set(_vm.stepForm, "parentId", $$v);
            },
            expression: "stepForm.parentId"
          }
        })], 1)];
      }
    }], null, false, 768622716)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.parentalTenantWarning')))])])], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": "",
      "disabled": !_vm.hasMultipleTenants
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c(VAutocomplete, {
          attrs: {
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addGroups'),
            "items": _vm.deviceGroups,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "disabled": _vm.hasMultipleTenants,
            "filled": _vm.inpFilled,
            "hide-details": "",
            "multiple": "",
            "small-chips": ""
          },
          model: {
            value: _vm.stepForm.groupsTags,
            callback: function ($$v) {
              _vm.$set(_vm.stepForm, "groupsTags", $$v);
            },
            expression: "stepForm.groupsTags"
          }
        })], 1)];
      }
    }], null, false, 1396583369)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTagsWarning')))])])], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": "",
      "disabled": !_vm.hasMultipleTenants
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('core-tags', {
          attrs: {
            "tags": _vm.get(_vm.deviceTags, 'tags', []),
            "height": "56",
            "tagListType": "virtualDevice",
            "disabled": _vm.hasMultipleTenants,
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTags')
          },
          on: {
            "update:tags": _vm.setTags
          }
        })], 1)];
      }
    }], null, false, 4258267976)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTagsWarning')))])])], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": "",
      "disabled": !_vm.hasMultipleTenants
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c(VAutocomplete, {
          attrs: {
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.removeGroups'),
            "items": _vm.deviceGroups,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "disabled": _vm.hasMultipleTenants,
            "filled": _vm.inpFilled,
            "hide-details": "",
            "multiple": "",
            "small-chips": ""
          },
          model: {
            value: _vm.stepForm.groupsToRemove,
            callback: function ($$v) {
              _vm.$set(_vm.stepForm, "groupsToRemove", $$v);
            },
            expression: "stepForm.groupsToRemove"
          }
        })], 1)];
      }
    }], null, false, 1283568690)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTagsWarning')))])])], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTooltip, {
    attrs: {
      "bottom": "",
      "disabled": !_vm.hasMultipleTenants
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('core-tags', {
          attrs: {
            "tags": _vm.get(_vm.deviceTagsToRemove, 'tags', []),
            "height": "56",
            "tagListType": "virtualDevice",
            "disabled": _vm.hasMultipleTenants,
            "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.removeTags')
          },
          on: {
            "update:tags": _vm.setTagsToRemove
          }
        })], 1)];
      }
    }], null, false, 2261584527)
  }, [_c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.addTagsWarning')))])])], 1)], 1), [_vm.removeTagsContainsAddTags ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#00000061",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.matchingTagsToAddAndTagsToRemove.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.matchingTagsToAddAndTagsToRemove.text')) + "\n              ")])]) : _vm._e()], [_vm.removeGroupsContainsAddGroups ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#00000061",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.matchingGroupssToAddAndGroupssToRemove.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.matchingGroupssToAddAndGroupssToRemove.text')) + "\n              ")])]) : _vm._e()], _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.isContinueBtnDisabled,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n              ")])], 1)], 1)], 2) : _vm._e(), _vm.stepForm.selectMode === _vm.modes.LINK_DEVICES_TO_A_TEMPLATE ? _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [!_vm.linkSelectionToTemplateCheck.summary ? [!_vm.linkSelectionToTemplateCheck.hasSameDrivers ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentDrivers.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentDrivers.text')) + "\n              ")])]) : _vm._e(), !_vm.linkSelectionToTemplateCheck.hasSameAccount ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentAccounts.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentAccounts.text')) + "\n              ")])]) : _vm._e(), !_vm.linkSelectionToTemplateCheck.hasSameConnectors ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentConnectors.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.differentConnectors.text')) + "\n              ")])]) : _vm._e(), !_vm.linkSelectionToTemplateCheck.alreadyLinked ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.alreadyLinked.title')) + "\n              "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.alreadyLinked.text')) + "\n              ")])]) : _vm._e()] : [_c(VRow, [_vm.deviceTemplatesData.isLoading ? _c(VCol, {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color
    }
  })], 1) : _vm._e(), !_vm.deviceTemplatesData.isLoading && _vm.deviceTemplatesData.templates.length === 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.noTemplatesFound.title')) + "\n                  "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.noTemplatesFound.text')) + "\n                  ")])])], 1) : _vm._e(), _vm.deviceTemplatesData.templates.length > 0 ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    staticClass: "mt-2",
    attrs: {
      "loading": _vm.deviceTemplatesData.isLoading,
      "items": _vm.deviceTemplatesData.templates,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.deviceTemplatesLabel'),
      "item-text": "text",
      "item-value": "id",
      "color": _vm.color,
      "outlined": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-item",
      fn: function () {
        return [_c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endTemplatesIntersect,
            expression: "endTemplatesIntersect"
          }]
        })];
      },
      proxy: true
    }], null, false, 2574592250),
    model: {
      value: _vm.stepForm.deviceTemplates,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "deviceTemplates", $$v);
      },
      expression: "stepForm.deviceTemplates"
    }
  })], 1) : _vm._e()], 1), _c(VRow, [!_vm.deviceTemplatesData.isLoading && _vm.deviceTemplatesData.templates.length > 0 ? _c(VCol, {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.isContinueBtnDisabled,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n                ")])], 1) : _vm._e()], 1)]], 2) : _vm._e(), _vm.stepForm.selectMode === _vm.modes.DELETE_ALL_SELECTED_DEVICES ? _c(VStepperContent, {
    attrs: {
      "step": "2"
    }
  }, [!_vm.hasDeviceThatReadFromExternalSystem ? _c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.noConfigurationsNeeded')) + "\n          ")]) : _c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.doYouWantToDeleteFromExternalSystem')) + "\n          ")]), _vm.hasDeviceThatReadFromExternalSystem ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.removeFromExternalSystem,
      "item-text": "text",
      "item-value": "value",
      "color": _vm.color,
      "outlined": ""
    },
    model: {
      value: _vm.stepForm.removeFromExternalSystem,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "removeFromExternalSystem", $$v);
      },
      expression: "stepForm.removeFromExternalSystem"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.isContinueBtnDisabled,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        _vm.step = 3;
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n              ")])], 1)], 1)], 1) : _vm._e(), _vm.stepForm.selectMode === _vm.modes.DELETE_ALL_SELECTED_DEVICES ? _c(VStepperContent, {
    attrs: {
      "step": "3"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesTitle')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesLabel'),
      "rules": _vm.rules,
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.stepForm.title,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "title", $$v);
      },
      expression: "stepForm.title"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.allDevicesWillBeDeleted')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.numberOfVirtualDevices'),
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.stepForm.numberOfVirtualDevices,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "numberOfVirtualDevices", $$v);
      },
      expression: "stepForm.numberOfVirtualDevices"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesInfo')))]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.applyBtnDisabled,
      "appendIcon": "fa-check"
    },
    on: {
      "click": _vm.applyChanges
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyBtn')) + "\n          ")])], 1) : _c(VStepperContent, {
    attrs: {
      "step": "3"
    }
  }, [_vm.stepForm.selectMode === _vm.modes.LINK_DEVICES_TO_A_TEMPLATE ? _c(VAlert, {
    attrs: {
      "icon": "fas fa-exclamation-circle",
      "color": "#ff5500",
      "density": "compact",
      "theme": "dark"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.warning.dropDataStates.title')) + "\n            "), _c('p', {
    staticClass: "mt-2 mb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.warning.dropDataStates.text')) + "\n            ")])]) : _vm._e(), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesTitle')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesLabel'),
      "rules": _vm.rules,
      "autocomplete": "off",
      "required": ""
    },
    model: {
      value: _vm.stepForm.title,
      callback: function ($$v) {
        _vm.$set(_vm.stepForm, "title", $$v);
      },
      expression: "stepForm.title"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyChangesInfo')))]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": _vm.applyBtnDisabled,
      "appendIcon": "fa-check"
    },
    on: {
      "click": _vm.applyChanges
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.applyBtn')) + "\n          ")])], 1)], 1)], 1)]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };